module.exports = __webpack_public_path__ + "img/adf3346.png";